import "./partners-page.scss";

import { Page } from "modules/Page";


export class PartnersPage extends Page<typeof PartnersPage> {
    public static readonly className = "js-partners-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.initCategoriesTabs();
        this.initShowMoreButtons();
        this.addSmoothScroll();
    }

    public initCategoriesTabs() {
        const categories = this.rootElement.querySelectorAll(".tab-categories > div");
        const tabButtons = this.rootElement.querySelectorAll(".tab-list li");

        // Handle tab click events
        tabButtons.forEach((tab) => {
            tab.addEventListener("click", () => {
                const isActive = tab.classList.contains("active");
                const tabId = tab.getAttribute("data-item");
                const tabContent = this.rootElement.querySelectorAll(`div[data-item="${tabId}"]`);

                if (isActive) {
                    return;
                }

                // Close all tabs
                tabButtons.forEach((otherTab) => otherTab.classList.remove("active"));
                categories.forEach((category) => category.classList.remove('active'));

                // Open clicked tab if not already active
                if (!isActive) {
                    tab.classList.add("active");
                    tabContent[0].classList.add('active');
                }
            });
        });
    }

    public initShowMoreButtons() {
        const showMoreButtons = this.rootElement.querySelectorAll(".show-more button");

        showMoreButtons.forEach((button) => {
            const index = parseInt(button.id.at(-1)!);
            const tabContent = this.rootElement.querySelectorAll(`div[data-item="${index}"] .card`);
            const showingCountElement = this.rootElement.querySelector<HTMLSpanElement>(`#showing-count-${index}`);
            const totalCountElement = this.rootElement.querySelector<HTMLSpanElement>(`#total-count-${index}`);
            const totalCount = tabContent.length;
            let showingCount = 6;

            // Hide extra cards initially
            tabContent.forEach((card, cardIndex) => {
                if (cardIndex < showingCount) {
                    card.classList.remove("hidden");
                }
            });

            button.addEventListener("click", () => {
                const newShowingCount = Math.min(showingCount + 6, totalCount);

                tabContent.forEach((card, cardIndex) => {
                    if (cardIndex < newShowingCount) {
                        card.classList.remove("hidden");
                    }
                });

                showingCount = newShowingCount;
                if (showingCountElement) {
                    showingCountElement.innerText = showingCount.toString();
                }

                if (showingCount >= totalCount) {
                    (button as HTMLElement).style.display = "none";
                }
            });

            if (totalCountElement) {
                totalCountElement.innerText = totalCount.toString();
            }
        });
    }

    public addSmoothScroll() {
        const html = document.querySelector("html");

        if (html) {
            html.classList.add("html-scroll__smooth");
        }
    }
}